export default "__VITE_ASSET__BJrLr2w8__"